import { ReactNode } from "react";
import { CardsContainer, CardsLayout } from "../Dashboard.styles";
import { DashboardDestinations } from "../Dashboard.types";
import { AlertsCard } from "./AlertsCard";
import { OrdersCard } from "./OrdersCard";
import { ProductResourcesCard } from "./ProductResourcesCard";

export interface DashboardCardsProps {
	destinations: DashboardDestinations;
	adSlot?: ReactNode;
}

export const DashboardCards = ({ destinations, adSlot }: DashboardCardsProps) => {
	const cardCount = adSlot ? 4 : 3;

	return (
		<CardsContainer>
			<CardsLayout
				cardCount={cardCount}
				data-card-count={cardCount}
				data-testid="dashboard-cards"
			>
				<OrdersCard />
				<AlertsCard destinations={destinations} />
				<ProductResourcesCard destinations={destinations} />
				{adSlot}
			</CardsLayout>
		</CardsContainer>
	);
};
